import React from 'react';
import PropTypes from 'prop-types';
import styles from './ColorPicker.module.scss';
import Color from 'color';
import Check from '../../../assets/svg/Feather/Check';

function ColorOption(props) {
  let colorObj = new Color(props.color);
  const backgroundColor = props.color;
  const borderColor = colorObj.hex() == '#000000' ? '#ffffff' : '#262627'; 
  const checkColor = ['#FFCC00', '#FFFFFF'].includes(colorObj.hex()) ? '#000000' : '#ffffff';
  const reactStyles = {
    border: `2px solid ${checkColor}`,
    display: props.checked ? 'flex' : 'none'
  }

  return <div className={styles.colorOptionContainer}>
    <div style={reactStyles} className={styles.selectedCheck}>
      <Check width={16} color={checkColor} />
    </div>
    <label
      htmlFor={props.color}
      className={styles.colorOptionLabel}
      style={{backgroundColor, borderColor}}
    >
    </label>
    <div className={styles.formInput}>
      <input
        aria-label={props.color}
        type='radio'
        onChange={props.onChange}
        id={props.color}
        value={props.color} 
        name={props.name} 
        checked={props.checked}
      />
    </div>
  </div>;
}

ColorOption.propTypes = {
  color: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
};
export default function ColorPicker(props) {
  return (
    <div className={ styles.colorPickerContainer }>
      { props.colorOptions.map(
          (color) => (
            <ColorOption
              key={color}
              checked={color == props.value}
              color={color} 
              name={props.name}
              onChange={props.onChange}
            />
          )
        ) 
      }
    </div>
  );
}

ColorPicker.propTypes = {
  colorOptions: PropTypes.array,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func
};
